import { Chart } from './Chart'
import type { ApexOptions } from 'apexcharts'
import i18n from '../../translations'

class StackedColumnChart extends Chart {
  constructor() {
    super()
  }
  options = {
    ...this.options,
    chart: {
      ...this.options.chart,
      type: 'bar',
      zoom: {
        enabled: false
      },
      stacked: true,
      height: '350px'
    },
    series: [],
    colors: [],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 4,
        columnWidth: '20%'
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: []
    },
    legend: {
      show: false
    },
    fill: {
      opacity: 0,
      type: 'gradient',
      gradient: {
        type: 'vertical',
        shade: 'light',
        shadeIntensity: 0.3,
        inverseColors: true
      }
    },
    tooltip: {
      followCursor: true,
      shared: false,
      custom: function ({ series, dataPointIndex, w }) {
        let currentTotal = 0
        const tab = []
        series.forEach((s) => {
          currentTotal += s[dataPointIndex]
        })
        w.globals.initialSeries.forEach((s) => {
          tab.push({ key: s.name, value: s.data[dataPointIndex] })
        })
        const label = w.globals.labels[dataPointIndex] ? w.globals.labels[dataPointIndex] : ''
        const a = []

        for (let i = 0; i < tab.length; i++) {
          const tst = `<div class="flex justify-between w-60"><p class="pb-2 px-1">${tab[i].key}</p><p class="pb-2 px-1 font-semibold" id="data-col-${i}" style="color:${w.globals.colors[i]};">${tab[i].value}</p></div>`
          a.push(tst)
        }

        return `<div class="w-full flex flex-col">
            <p class="p-3 font-medium text-white bg-primary text-center">
            ${label}
            </p>
            <div class="p-2 font-semibold text-foreground bg-stone-200 flex justify-between">
              <p>${i18n.global.t('global.total')}</p><p>${currentTotal}</p>
            </div>
            <div class="p-1">
              ${a.join(' ')}
            </div>
          </div>`
      }
    }
  } as ApexOptions

  setSeries(series: Array<{ name: string; data: [] }>): void {
    this.options.series = series
  }

  setColor(color: string[]): void {
    this.options.colors = color
  }

  setCategories(categories: string[]): void {
    this.options = {
      ...this.options,
      ...{
        xaxis: {
          ...this.options.xaxis,
          categories: categories
        }
      }
    }
  }
}

export { StackedColumnChart }
